import React from 'react';
import Link from 'next/link';
import styled from '@emotion/styled';

const LinkContainer = styled.div(({ theme }) => ({
  fontFamily: '"Source Sans 3", sans-serif',
  fontSize: '1rem',
  fontWeight: 500,
  lineHeight: 1.5,
  color: theme?.palette?.text?.medium || '#424242',
  textAlign: 'center',
  width: '100%',
  overflowWrap: 'anywhere',
  wordBreak: 'break-word',
  margin: 0,
}));

const StyledAnchor = styled.a(({ theme }) => ({
  color: theme?.palette?.primary?.main || '#005eb8',
  textDecoration: 'underline',
  overflowWrap: 'anywhere',
  wordBreak: 'break-word',
}));

/**
 * @param {{
 *   link?: { href?: string; target?: string | null; text?: string };
 *   fallbackText?: string;
 *   title?: string;
 *   containerElement?: React.ElementType;
 *   containerClassName?: string;
 *   linkClassName?: string;
 *   containerStyle?: React.CSSProperties;
 * }} props
 */
const DisplayLink = ({
  link,
  fallbackText = 'Read More',
  title = undefined,
  containerElement = 'div',
  containerClassName = '',
  linkClassName = '',
  containerStyle = undefined,
}) => {
  if (!link?.href) {
    return null;
  }

  const linkText = link?.text || fallbackText;

  return (
    <LinkContainer
      as={containerElement}
      className={containerClassName}
      style={containerStyle}
    >
      <Link href={link.href} passHref legacyBehavior>
        <StyledAnchor
          target={link?.target || '_self'}
          rel={link?.target === '_blank' ? 'noopener noreferrer' : undefined}
          title={title || linkText}
          className={linkClassName}
        >
          {linkText}
        </StyledAnchor>
      </Link>
    </LinkContainer>
  );
};

export default DisplayLink;
